import React, { useState, useEffect, useRef, useContext } from "react";

import { useTranslation } from 'react-i18next';
import { AuthContext } from "../../../authContext";
import './administrators.css'

import ConfirmDeleteModal2 from "../../../components/DeletAssitant";

import LoadingSpinner from "../../../components/LoadingSpinner";


// administrators/index.js (Componente CORRIGIDO)

const CustomDropdown = ({ placeholder, options, selected, setSelected, disabled, errorClassName = '' }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (value) => {
        setSelected(value);
        setOpen(false);
    };

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // <<< A LINHA QUE FALTAVA ESTÁ AQUI >>>
    // Esta linha cria a string de classes CSS com base nos estados 'open' e 'selected'
    const selectInputClasses = `select-input ${open ? 'open' : ''} ${selected ? 'selected' : ''} ${errorClassName ? 'input-error' : ''}`;

    return (
        <div className={`select-container ${disabled ? 'disabled' : ''}`} ref={dropdownRef}>
            <div
                className={selectInputClasses} // Agora a variável existe e pode ser usada aqui
                onClick={() => !disabled && setOpen(prev => !prev)}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                tabIndex={0}
            >
                {selected ? selected : <span className="placeholder">{placeholder}</span>}
                <img src="/imagens/seta.svg" className="select-icon" alt="seta" />
            </div>
            {open && (
                <ul className="dropdown">
                    {options.map((option, idx) => (
                        <li key={idx} onClick={() => handleSelect(option)}>{option}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};


function AdminContent() {
    const { t: tHub } = useTranslation('hub');
    const { t: tManagement } = useTranslation('management');
    const { t: tCommon } = useTranslation('common');
    const { accessToken } = useContext(AuthContext);
    const [admins, setAdmins] = useState([]);
    const [allUsers, setAllUsers] = useState([]); // Lista de todos os usuários
    const [loading, setLoading] = useState(true);
    const [expandedAdms, setExpandedAdms] = useState({})
    const [assistantsMap, setAssistantsMap] = useState({});
    const [loadingAssistants, setLoadingAssistants] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState(null); // Armazena o admin a ser deletado
    const [deleteType, setDeleteType] = useState(null); // 'admin' or 'assistant'
    const [assistantToDelete, setAssistantToDelete] = useState(null);
    const [assistantOwnerEmail, setAssistantOwnerEmail] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const [showUserPopup, setShowUserPopup] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [hierarquia, setHierarquia] = useState('');
    const [unidade, setUnidade] = useState('');
    const [camposValidos, setCamposValidos] = useState(false);
    const [formTocado, setFormTocado] = useState(false);
    const [expandedAssistants, setExpandedAssistants] = useState(null);

    // Estados para verificação de domínio
    const [allowedDomains, setAllowedDomains] = useState([]);
    const [alertType, setAlertType] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [refetchTrigger, setRefetchTrigger] = useState(0);

    // Auto close alert after 5 seconds
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    const truncate = (s, n = 32) => (s?.length > n ? s.slice(0, n - 1) + '…' : s);

    // useEffect para buscar domínios permitidos
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/get_domains`)
            .then(response => response.json())
            .then(data => {
                const onlyDomains = data.map(d => d.dominio.toLowerCase().trim());
                setAllowedDomains(onlyDomains);
            })
            .catch(err => console.error("Erro ao buscar domínios permitidos:", err));
    }, []);

    // Função para verificar se o domínio do email é permitido
    const isAllowedDomain = (email) => {
        const domain = email.split('@')[1].toLowerCase().trim();
        const normalizedDomains = allowedDomains.map(d => d.toLowerCase().trim());
        return normalizedDomains.includes(domain);
    };

    useEffect(() => {
        setCamposValidos(!!(nome && email && hierarquia && unidade));
    }, [nome, email, hierarquia, unidade]);

    const handleDeleteClick = (admin) => {
        setDeleteType('admin');
        setSelectedAdmin(admin);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedAdmin(null);
        setDeleteType(null);
        setAssistantToDelete(null);
        setAssistantOwnerEmail(null);
    };

    const handleConfirmDelete = async () => {
        // Remove o usuário visualmente imediatamente
        const adminToDelete = selectedAdmin;
        setAdmins((prev) => prev.filter((a) => a.email !== adminToDelete.email));

        // Fecha o modal imediatamente
        handleCloseModal();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/delete_user`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ email: adminToDelete.email }),
            });

            const result = await response.json();

            if (!result.success) {
                // Se falhou, restaura o usuário na lista
                console.error(result.message || result.error);
                setAdmins((prev) => [...prev, adminToDelete].sort((a, b) => a.name.localeCompare(b.name)));
            }
        } catch (error) {
            // Se houve erro na requisição, restaura o usuário na lista
            console.error('Erro ao deletar usuário:', error);
            setAdmins((prev) => [...prev, adminToDelete].sort((a, b) => a.name.localeCompare(b.name)));
        }
    };

    const handleConfirmDeleteAssistant = async () => {
        if (!assistantToDelete || !assistantOwnerEmail) return;

    // Optimistically remove assistant from UI
    const prevAssistants = assistantsMap[assistantOwnerEmail] || [];
    const newAssistants = prevAssistants.filter(a => a.id !== assistantToDelete);
        setAssistantsMap(prev => ({ ...prev, [assistantOwnerEmail]: newAssistants }));
    // Also decrement count in admins list optimistically
        setAdmins(prev => prev.map(adm => adm.email === assistantOwnerEmail ? { ...adm, assistants_count: Math.max(0, (adm.assistants_count || 1) - 1) } : adm));

        // Close modal
        handleCloseModal();

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/delete_assistant`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ assistant_id: assistantToDelete }),
            });

            if (!res.ok) {
                throw new Error(`Erro ao deletar assistente. Status: ${res.status}`);
            }

            // Optionally check response body for success
            const data = await res.json().catch(() => ({}));
            if (data && data.success === false) {
                throw new Error(data.message || 'Falha ao apagar assistente');
            }

        } catch (err) {
            console.error('Erro ao deletar assistente:', err);
            // restore previous state on failure
            setAssistantsMap(prev => ({ ...prev, [assistantOwnerEmail]: prevAssistants }));
            setAdmins(prev => prev.map(adm => adm.email === assistantOwnerEmail ? { ...adm, assistants_count: (adm.assistants_count || 0) + 1 } : adm));
            // show alert
            setAlertType('error');
            setAlertMessage('Não foi possível excluir o assistente.');
            setShowAlert(true);
        }
    };

    const [isHovered, setIsHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleExitModal = () => {
        setShowModal(false);
        setSelectedAdmin(null);
        // Adicione o reset aqui também
        resetFormularioCadastro();
    };
    const [searchQuery, setSearchQuery] = useState('');

    // Função para filtrar usuários que não são administradores
    const getNonAdminUsers = () => {
        if (!allUsers || !admins) return [];

        const adminEmails = new Set(admins.map(admin => admin.email));
        return allUsers.filter(user => !adminEmails.has(user.email));
    };

    const resetFormularioCadastro = () => {
        setNome('');
        setEmail('');
        setHierarquia('');
        setUnidade('');
        setFormTocado(false); // <-- ADICIONE ESTA LINHA
    };

    const [isRegistering, setIsRegistering] = useState(false); // Novo estado para controlar o carregamento do cadastro

    const handleCadastro = async () => {
        setFormTocado(true); // Marca que o usuário tentou submeter
        let hierarquia2
        if (camposValidos) {
            // Verifica se o e-mail é válido
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            if (!isValidEmail) {
                setAlertType("error");
                setAlertMessage(tManagement('email_valido') || "Digite um e-mail válido");
                setShowAlert(true);
                return;
            }

            // Verifica se o domínio é permitido
            if (!isAllowedDomain(email)) {
                setAlertType("error");
                setAlertMessage(tManagement('dominio_valido') || "Este domínio não está permitido");
                setShowAlert(true);
                return;
            }

            if (hierarquia === 'Administrador') {
                hierarquia2 = 'adm'
            } else if (hierarquia === 'Moderador') {
                hierarquia2 = 'mod'
            }

            setIsRegistering(true); // Inicia o carregamento

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/post_create_user`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${accessToken}` // se usar JWT
                    },
                    body: JSON.stringify({
                        name: nome,
                        email: email,
                        user: nome, // ou outro campo que represente "user"
                        role: hierarquia2, // ou "admin"
                        business_unit: unidade
                    })
                });

                const data = await res.json();
                if (data.status) {
                    console.log("Usuário criado com sucesso!");
                    setShowModal(false);
                    resetFormularioCadastro();
                    setRefetchTrigger(prev => prev + 1);
                    setAlertType("success");
                    setAlertMessage("Usuário cadastrado com sucesso!");
                    setShowAlert(true);
                } else {
                    console.error("Erro:", data.error);
                    setAlertType("error");
                    setAlertMessage(data.error || "Erro ao cadastrar usuário");
                    setShowAlert(true);
                }
            } catch (err) {
                console.error("Falha na API:", err);
                setAlertType("error");
                setAlertMessage("Falha na comunicação com o servidor");
                setShowAlert(true);
            } finally {
                setIsRegistering(false); // Finaliza o carregamento
            }
        }
    };


    const toggleExpand = async (email) => {
        setExpandedAdms(prev => ({
            ...prev,
            [email]: !prev[email],
        }));

        // Só busca se ainda não tiver
        if (!assistantsMap[email]) {
            setLoadingAssistants(prev => ({ ...prev, [email]: true }));
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/post_assistants`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({ email })
                });

                const data = await response.json();

                if (data) {
                    setAssistantsMap(prev => ({
                        ...prev,
                        [email]: data.assistants
                    }));
                } else {
                    console.error("Erro ao buscar assistentes para", email);
                }
            } catch (err) {
                console.error("Erro na chamada post_assistants:", err);
            } finally {
                setLoadingAssistants(prev => ({ ...prev, [email]: false }));
            }
        }
    };

    const handleSaveAdmin = async () => {
        if (!selectedAdmin) return;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/put_user_to_admin`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
                body: JSON.stringify({ email: selectedAdmin })
            });

            const data = await res.json();

            if (data.status) {
                console.log("Promovido com sucesso:", data.message);
                setSelectedAdmin(null);
            } else {
                console.error("Erro:", data.error);
            }

        } catch (err) {
            console.error("Falha na API:", err);
        }
    };



    useEffect(() => {
        async function fetchData() {
            try {
                // Buscar administradores
                const adminsResponse = await fetch(`${process.env.REACT_APP_API_URL}/get_admins_and_devs`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                const adminsData = await adminsResponse.json();
                if (adminsData.success) {
                    // Assumindo que a API agora retorna: { email, name, assistants_count }
                    setAdmins(adminsData.users);
                }

                if (adminsData.success) {
                    setAdmins(adminsData.users);
                }

                // Buscar todos os usuários
                const allUsersResponse = await fetch(`${process.env.REACT_APP_API_URL}/get_list_non_admin`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                const allUsersData = await allUsersResponse.json();
                setAllUsers(allUsersData);

            } catch (err) {
                console.error('Erro ao buscar dados:', err);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [accessToken, refetchTrigger]);


    if (loading) return <LoadingSpinner />;



    return (
        <div className="admin-grid" data-testid="admin-grid">
            <div className="admin-header-wrapper">
                <button
                    className="rl-btn-icon-admin"
                    title={tCommon('addAdministrator')}
                    onClick={() => setShowModal(true)}
                >
                    +
                </button>
                <div className="search-container-management-admin">
                    <input
                    type="text"
                    className="publish-input-admin"
                    placeholder={tManagement("search")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <img
                    src="/imagens/search.svg"
                    alt={tCommon("searchIcon")}
                    className="publish-search-icon-admin"
                    />
                </div>
            </div>

            {admins
                .filter(admin =>
                    admin.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    admin.email?.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((admin) => (

                    <div className={`admin-card ${expandedAdms[admin.email] ? 'expanded' : ''}`} key={admin.email}>
                        <div className="admin-card-top">
                            <div className="admin-card-header">
                                <div className="admin-avatar">{admin.name?.[0].toUpperCase()}</div>
                                <div className="admin-info">
                                    <p className="admin-name">{admin.name}</p>
                                    <p className="admin-email" title={admin.email}>
                                        {truncate(admin.email, 32)}
                                    </p>
                                </div>
                            </div>

                            <button
                                className="btn-admin-details"
                                onClick={() => toggleExpand(admin.email)}
                            >
                                <img src="/imagens/assistants.svg" alt="" />
                                <img
                                    src="/imagens/down_icon.svg"
                                    alt=""
                                    style={{
                                        transform: expandedAdms[admin.email] ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                            </button>
                        </div>

                        <div className={`admin-expandable ${expandedAdms[admin.email] ? 'expanded' : ''}`}>
                            <p className="assistants-section-label">{tManagement("assistentes_adm")}</p>
                            <div className="admin-assistants">
                                {loadingAssistants[admin.email] ? (
                                    <LoadingSpinner />
                                ) : (() => {
                                    const list = (assistantsMap[admin.email]
                                        ?.filter(assistant => assistant.adms?.some(adm => adm.email === admin.email))
                                        || []);
                                    if (assistantsMap[admin.email] !== undefined && list.length === 0) {
                                        return <p className="no-assistants-msg">{tManagement("no_assistants")}</p>;
                                    }
                                    return list.map((assistant) => (
                                        <div className="assistant-item" key={assistant.id}>
                                            <div className="area-icon">
                                                <div className="assistant-icon">
                                                    <div className="assistant-icon">
                                                        {assistant.icon
                                                            ? <div dangerouslySetInnerHTML={{ __html: assistant.icon }} />
                                                            : <img src="/imagens/AndroidLogo.svg" alt={tCommon('defaultAssistant')} />}
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="assistant-name-admin">{assistant.nome || "---"}</p>
                                            <img
                                                className="assistant-delete"
                                                src="/imagens/exclude-red.svg"
                                                alt="deletar"
                                                onClick={() => {
                                                    setDeleteType('assistant');
                                                    setAssistantToDelete(assistant.id);
                                                    setAssistantOwnerEmail(admin.email);
                                                    setIsModalOpen(true);
                                                }}
                                            />
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                ))}
            <ConfirmDeleteModal2
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={() => {
                    if (deleteType === 'assistant') {
                        handleConfirmDeleteAssistant();
                    } else {
                        handleConfirmDelete();
                    }
                }}
            />

            {/* Modal para adicionar novo administrador */}
            {showModal && (
                <div className="modal-overlay">
                    <div
                            className="popUp"
                        >
                            <div className="popUp-header">
                                <h2 className="popUp-header-tittle">{tManagement("adm_adc")}</h2>
                                <img 
                                    src="/imagens/x.svg" 
                                    alt={tCommon('closeIcon')} 
                                    className="popUp-header-icon" 
                                    onClick={() => { handleExitModal(); setShowUserPopup(false); resetFormularioCadastro(); }} />
                            </div>
                            <div className="popUp-input-group">
                                <span className="popup-span">{tManagement("user")}</span>
                                <input className={`input-name ${formTocado && !nome ? 'input-error' : ''}`} type="text" placeholder={tManagement("username")} value={nome} onChange={(e) => setNome(e.target.value)} />
                                <span className="popup-span">Email</span>
                                <input className={`input-email ${formTocado && !email ? 'input-error' : ''}`} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                <div className="select-wrapper">
                                    <span className="popup-span">{tManagement("hierarchy")}</span>
                                    <CustomDropdown
                                        placeholder={tManagement('selectHierarchy')}
                                        options={["Administrador", "Moderador"]}
                                        selected={hierarquia}
                                        setSelected={(value) => {
                                            setHierarquia(value);
                                            setUnidade(''); // resetar unidade
                                        }}
                                        errorClassName={formTocado && !hierarquia ? 'input-error' : ''}
                                    />

                                    <span className="popup-span">{tManagement("business_unit")}</span>
                                    <CustomDropdown
                                        placeholder={tManagement("BU")}
                                        options={[
                                            "CETEST", "Synergia", "TPF Consultores", "TPF Engineering", "TPF Engineering PVT",
                                            "TPF Engenharia", "TPF Ingenierie", "TPF Ingeniería", "TPF Romania", "TPF Sp Z.o.o"
                                        ]}
                                        selected={unidade}
                                        setSelected={setUnidade}
                                        disabled={!hierarquia}
                                        errorClassName={formTocado && !unidade ? 'input-error' : ''}
                                    />
                                </div>
                            </div>

                            <button className="popUp-button"
                                disabled={(!camposValidos && formTocado) || isRegistering} // Desabilita também durante o cadastro
                                onClick={handleCadastro}
                            >
                                <span>{isRegistering ? tManagement("salvando") : tManagement("salvar")}</span>
                            </button>

                            {showAlert && (
                                <div className="popup-alert">
                                    <div className={`popup-alert-content ${alertType}`}>
                                        <div className="popup-alert-icon">
                                            {alertType === 'error' && '⚠️'}
                                            {alertType === 'success' && '✅'}
                                        </div>
                                        <div className="popup-alert-text">
                                            <span className="popup-alert-message">{alertMessage}</span>
                                        </div>
                                        <button 
                                            className="popup-alert-close"
                                            onClick={() => setShowAlert(false)}
                                        >
                                            ×
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                </div>
            )}
        </div>
    );
}

export default AdminContent;